import { type FC, type ReactElement } from "react";

import { ColoredLabel } from "widgets";
import { formatNumberWithPrecision } from "widgets/utils";

import { getDataSeriesKey } from "../../app-utils/chart-worker.js";
import { pluralizeWord } from "../../app-utils/string.js";
import { type ICondition } from "./DatasetChart.js";
import { CHART_TYPE, type ChartType } from "@/settings/settings.js";

export interface ICustomChartTooltipProps {
  payload?: any;
  type?: string; // not used currently
  label?: string; // not correct when mutliple conditions are set
  chartType?: ChartType;
}

/**
 * Custom chart tooltip with injected props
 *
 * created on 3/2/2017
 */
const CustomChartTooltip: FC<ICustomChartTooltipProps> = (props) => {
  const { payload } = props;
  const conditions: ICondition[] = payload?.[0] ? payload[0].payload.conditions : [];
  const labels: string[] = conditions.map((condition: ICondition) => condition.label);
  const values: string[] = conditions.map((condition: ICondition) => condition.value);

  const dataSeriesRows: ReactElement[] = [];
  const knownSeries: any = {};

  function addToArray(element: ReactElement) {
    // in case of line plot the data series are displayed from bottom to top (reverse way) so that the first data series are on the top
    // therefore we need to display the tooltip differently
    props.chartType === CHART_TYPE.LINE ? dataSeriesRows.unshift(element) : dataSeriesRows.push(element);
  }

  if (payload) {
    payload.forEach((dataSeriesPayload, index) => {
      const seriesKey: string = getDataSeriesKey(dataSeriesPayload.name);
      if (!knownSeries[seriesKey]) {
        const dataSeriesData = dataSeriesPayload.payload.dataseries[seriesKey];
        if (dataSeriesData) {
          const rawData: any[] = dataSeriesData.rawData;
          const value: number = formatNumberWithPrecision(dataSeriesData.consolidatedValue);

          addToArray(
            <div>
              <ColoredLabel key={`custom-tooltip-${index}`} color={dataSeriesPayload.fill || dataSeriesPayload.stroke}>
                <strong>{dataSeriesPayload.name}:</strong> {value} ({rawData.length}{" "}
                {pluralizeWord("value", rawData.length)})
              </ColoredLabel>
            </div>,
          );
          knownSeries[seriesKey] = true;
        }
      }
    });
  }

  return (
    <div className="custom-tooltip">
      {dataSeriesRows}
      <div className="conditions">
        <strong>{labels.join(", ")}:</strong> {values.join(", ")}
      </div>
    </div>
  );
};

export default CustomChartTooltip;
